export { default } from "./Icon";
export type { IconName } from "./Icon";
